import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../common/Button";
import Thumbnail from "../../assets/campuses/summer-hero.png";
const Hero = ({ bg, title }) => {
  const navigate = useNavigate();

  return (
    <div className={bg}>
      <div className="max-w-[1805px]  w-full  flex justify-between pb-[123px] pt-[60px]">
        <div className="pl-[99px]">
          <h1 className="text-white mt-5 font-bold text-[80px] leading-[120px]">
            {title}
          </h1>
          <p className="mt-3 text-white text-xl tracking-[1%]  text-justify max-w-[949px]">
            Empower your child with coding skills this winter at our exciting
            Winter Coding Camp – specially designed for kids and teens to learn,
            create, and innovate during the holiday season. Through engaging
            projects in Scratch, Python, Web & App Development, Roblox, and Data
            Science, students explore the fascinating world of technology while
            boosting their creativity and confidence. <br /> Guided by expert
            instructors, each session is interactive and hands-on – encouraging
            problem-solving, teamwork, and technical growth. By the end of the
            camp, every participant will receive a certificate of achievement,
            recognizing their efforts and celebrating the valuable skills
            they’ve gained throughout their winter coding journey.
          </p>

          <p className="font-bold text-xl text-white mt-10 tracking-[1%]">
            Enroll today and make this summer unforgettable with code,
            creativity, and innovation!
          </p>
          <div className="flex items-center gap-[22px] mt-14">
            <Button
              btnText="Claim Your Spot Now"
              btnClassName={
                "tracking-[1%] py-[14.5px] px-[44.5px] text-xl rounded-full bg-white text-black font-semibold "
              }
              onClick={() => navigate("/camps/camps-registration")}
            />
            <h3 className="font-semibold text-xl text-white tracking-[1%]">
              Few slots remaining, hurry now!
            </h3>
          </div>
        </div>
        <div className="max-w-[623px]  w-full ">
          <div className="">
            <img src={Thumbnail} alt="thumbnail hero" className="w-full h-auto" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
